// Shared procedure type/status vocabulary for the IVF Procedures module —
// mirrors opdAppointments/constants.js's STATUS_LIST/STATUS_LABELS/STATUS_HEX
// pattern. Status colors match the `color` values already used by
// getStatusStyle() in layouts/ivfProcedures/index.js, so the dashboard
// widget and the procedure list page read as the same color language.

export const PROCEDURE_TYPE_LIST = ['IVF', 'IUI', 'ICSI', 'FET', 'OI', 'DONOR', 'SURROGACY', 'OTHER'];

export const PROCEDURE_TYPE_LABELS = {
  IVF: 'IVF',
  IUI: 'IUI',
  ICSI: 'ICSI',
  FET: 'FET',
  OI: 'OI',
  DONOR: 'Donor',
  SURROGACY: 'Surrogacy',
  OTHER: 'Other',
};

export const PROCEDURE_TYPE_HEX = {
  IVF: '#1A73E8',
  IUI: '#8E24AA',
  ICSI: '#00897B',
  FET: '#F57C00',
  OI: '#3949AB',
  DONOR: '#C2185B',
  SURROGACY: '#5D4037',
  OTHER: '#616161',
};

export const PROCEDURE_STATUS_LIST = ['CREATED', 'ONGOING', 'COMPLETED', 'CANCELLED', 'ON_HOLD'];

export const PROCEDURE_STATUS_LABELS = {
  CREATED: 'Created',
  ONGOING: 'Ongoing',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  ON_HOLD: 'On Hold',
};

export const PROCEDURE_STATUS_HEX = {
  CREATED: '#1565c0',
  ONGOING: '#2e7d32',
  COMPLETED: '#4527a0',
  CANCELLED: '#b71c1c',
  ON_HOLD: '#e65100',
};
